import { Component, OnInit, Input, ViewEncapsulation  } from '@angular/core';

@Component({
  selector: 'lib-angular-countdown-dateTime',
  templateUrl: './angular-countdown-date-time.html',
  styleUrls: ['./angular-countdown-date-time.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AngularCountdownDateTimeComponent implements OnInit {
  @Input()
  endDateBind: string;
  @Input()
  dayText: string;
  @Input()
  hourText: string;
  @Input()
  minutesText: string;
  @Input()
  secondsText: string;

  //endDate: Date = new Date('2019-04-23 00:00:00');
  endDate: Date;
  diff: number;
  countDownResult: number;
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
  dayTextBind: string;
  hourTextBind: string;
  minutesTextBind: string;
  secondsTextBind: string;
  constructor() {
    debugger;
  }

  ngOnInit() {
    debugger;
    this.endDate = new Date(this.endDateBind);

    setInterval(() => {
      let end = this.endDate.toDateString();
      let start = new Date().toDateString();
      this.diff = Math.floor((this.endDate.getTime() - new Date().getTime()) / 1000);
      this.dayTextBind = this.dayText;
      this.hourTextBind = this.hourText;
      this.minutesTextBind = this.minutesText;
      this.secondsTextBind = this.secondsText;
      this.days = this.getDays(this.diff);
      this.hours = this.getHours(this.diff);
      this.minutes = this.getMinutes(this.diff);
      this.seconds = this.getSeconds(this.diff);
    }, 1000);
  }

  getDays(t) {
    let days;
    days = Math.floor(t / 86400);
    return ('0' + days).slice(-2);
  }

  getHours(t) {
    let days, hours;
    days = Math.floor(t / 86400);
    t -= days * 86400;
    hours = Math.floor(t / 3600) % 24;
    return ('0' + hours).slice(-2);
  }

  getMinutes(t) {
    let days, hours, minutes;
    days = Math.floor(t / 86400);
    t -= days * 86400;
    hours = Math.floor(t / 3600) % 24;
    t -= hours * 3600;
    minutes = Math.floor(t / 60) % 60;
    return ('0' + minutes).slice(-2);
  }

  getSeconds(t) {
    let days, hours, minutes, seconds;
    days = Math.floor(t / 86400);
    t -= days * 86400;
    hours = Math.floor(t / 3600) % 24;
    t -= hours * 3600;
    minutes = Math.floor(t / 60) % 60;
    t -= minutes * 60;
    seconds = t % 60;
    return ('0' + seconds).slice(-2);
  }



}
